import moment from 'moment'

export const reportCPARPartial = {
    startDate : moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    isApprovedSR: false,
}
